import 'core-js/es7/array'
import 'core-js/fn/string/includes'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import ReduxPromise from 'redux-promise'
import ReduxThunk from 'redux-thunk'
import './index.css'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from './registerServiceWorker'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { PersistGate } from 'redux-persist/integration/react'
import './global-styles.js'
import GoogleTagManager from './components/Helpers/GoogleTagManager'

import reducers from './reducers'

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2
}

const persistedReducer = persistReducer(persistConfig, reducers)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const createStoreWithMiddleware = createStore(persistedReducer, /* preloadedState, */ composeEnhancers(
  applyMiddleware(ReduxPromise, ReduxThunk)
))
const persistor = persistStore(createStoreWithMiddleware)

ReactDOM.render(
  <Provider store={createStoreWithMiddleware}>
    <PersistGate loading={null} persistor={persistor}>
      <GoogleTagManager gtmId='GTM-WRDMWHV' />
      <App />
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root'))
unregister()



// WEBPACK FOOTER //
// ./src/index.js